<template>
    <div class="container summary" :class="{en: language === 'en'}">
        <div class="summary-row">
            <div class="summary-card">
                <div class="summary-header">
                    {{getLabel('INFORMATION_TITLE')}}
                    <span class="summary-edit" @click="jump('information')">{{getLabel('SUMMARY_EDIT')}}</span>
                </div>
                <div class="summary-content">
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_LEFT1_LABEL')}}</span>
                        <span
                            class="summary-value"
                            :class="{empty: !currentUser.family_name}"
                        >{{currentUser.family_name || getLabel('TIP_NOT_FILLED')}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_RIGHT1_LABEL')}}</span>
                        <span
                            class="summary-value"
                            :class="{empty: !currentUser.first_name}"
                        >{{currentUser.first_name || getLabel('TIP_NOT_FILLED')}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_LEFT2_LABEL')}}</span>
                        <span
                            class="summary-value"
                            :class="{empty: !currentUser.gender}"
                        >{{getGender(currentUser.gender) || getLabel('TIP_NOT_FILLED')}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_RIGHT2_LABEL')}}</span>
                        <span
                            class="summary-value"
                            :class="{empty: !currentUser.location}"
                        >
                            <template v-if="currentUser.location">{{getCountry(currentUser.location)}}</template>
                            <template v-else>{{getLabel('TIP_NOT_FILLED')}}</template>
                        </span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_LEFT3_LABEL')}}</span>
                        <span class="summary-value">{{currentUser.birthday}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_RIGHT3_LABEL')}}</span>
                        <span
                            class="summary-value"
                            :class="{empty: !currentUser.identity_number}"
                        >{{currentUser.identity_number || getLabel('TIP_NOT_FILLED')}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_LEFT4_LABEL')}}</span>
                        <span
                            class="summary-value"
                            :class="{empty: !currentUser.company}"
                        >{{currentUser.company || getLabel('TIP_NOT_FILLED')}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_RIGHT4_LABEL')}}</span>
                        <span
                            class="summary-value"
                            :class="{empty: !currentUser.post}"
                        >{{currentUser.post || getLabel('TIP_NOT_FILLED')}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_LEFT5_LABEL')}}</span>
                        <span
                            class="summary-value"
                            :class="{empty: !currentUser.phone_number}"
                        >{{currentUser.phone_number || getLabel('TIP_NOT_FILLED')}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_RIGHT5_LABEL')}}</span>
                        <span class="summary-value">{{currentUser.address}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_LEFT6_LABEL')}}</span>
                        <span class="summary-value">{{currentUser.assistant_name}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_RIGHT6_LABEL')}}</span>
                        <span class="summary-value">{{currentUser.assistant_email}}</span>
                    </div>
                    <div class="summary-info">
                        <span class="summary-label">{{getLabel('INFORMATION_LEFT7_LABEL')}}</span>
                        <span class="summary-value">{{currentUser.assistant_phone_number}}</span>
                    </div>
                </div>
                <div class="summary-tag" :class="{undone: not_finish_information}" @click="jump('information')"></div>
            </div>
            <div class="summary-card summary-activity">
                <div class="summary-header">
                    {{getLabel('ACTIVITY_TITLE')}}
                    <span class="summary-edit" @click="jump('activity')">{{getLabel('SUMMARY_EDIT')}}</span>
                </div>
                <div class="summary-content">
                    <div v-for="(activityDate, index) in sortedDate" :key="'activityDate_' + index">
                        <div class="summary-info summary-blue">{{activityDate}}</div>
                        <div class="summary-info summary-container"
                             :class="{isCheck: selectList.indexOf(activity.id) !== -1}"
                             v-for="(activity, index) in activityObj[activityDate]"
                             :key="'activity_' + index"
                        >

                            <span class="summary-label summary-activityLabel">
                                {{activity.start_time}} - {{activity.end_time}}
                            </span>
                            <span class="summary-value summary-activityValue">
                                <p class="summary-activityTitle">{{language === 'zh' ? activity.zh_name : activity.en_name}}</p>
                                <p class="summary-address">{{language === 'zh' ? activity.zh_address : activity.en_address}}</p>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="summary-tag" :class="{undone: not_finish_activity}" @click="jump('activity')"></div>
                <div class="summary-downTip">
                    <img src="../assets/img/down.png" class="summary-downArrow" />
                </div>
            </div>
            <div class="summary-card" v-if="currentUser.residence_city !== 1 && currentUser.charge_type === 1">
                <div class="summary-header">
                    {{getLabel('FLIGHT_TITLE')}}
                    <span class="summary-edit" @click="jump('flight')">{{getLabel('SUMMARY_EDIT')}}</span>
                </div>
                <div class="summary-content">
                    <template v-if="flightObj.book_mode === 2">
                        <div class="summary-title">{{getLabel('SUMMARY_ITINERARY')}}</div>
                        <div class="summary-card-img" v-if="flightObj['Itinerary_id'] && flightObj['Itinerary_id'].length">
                            <img :src="flightObj['Itinerary_id'][0]['url']" />
                        </div>
                    </template>
                    <template v-else-if="flightObj.book_mode === 3">
                        <template v-if="language === 'zh'">
                            <div class="summary-info">
                                <span class="summary-label">报销币种</span>
                                <span class="summary-value">{{flightObj.pay_currency}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">报销金额</span>
                                <span class="summary-value">{{flightObj.pay_money}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">银行名称</span>
                                <span class="summary-value">{{flightObj.bank_name}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">银行卡号</span>
                                <span class="summary-value">{{flightObj.bank_number}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">收款人姓名</span>
                                <span class="summary-value">{{flightObj.pay_name}}</span>
                            </div>
                        </template>
                        <template v-else>
                            <div class="summary-info">
                                <span class="summary-label">CURRENCY</span>
                                <span class="summary-value">{{flightObj.en_pay_currency}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">AMOUNT</span>
                                <span class="summary-value">{{flightObj.en_pay_money}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">BENEFICIARY’S BANK SWIFT CODE</span>
                                <span class="summary-value">{{flightObj.en_pay_bank_code}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">BENE’S BANK NAME</span>
                                <span class="summary-value">{{flightObj.en_pay_bank_name}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">BENE’S BANK ADDRESS</span>
                                <span class="summary-value">{{flightObj.en_pay_bank_address}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">BENE’S ACCOUNT NO/IBAN NO</span>
                                <span class="summary-value">{{flightObj.en_pay_bank_number}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">BENE’S ACCOUNT NAME</span>
                                <span class="summary-value">{{flightObj.en_pay_name}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">BENE’S ADDRESS</span>
                                <span class="summary-value">{{flightObj.en_pay_bank_address}}</span>
                            </div>
                            <div class="summary-info">
                                <span class="summary-label">E-MAIL ADDRESS</span>
                                <span class="summary-value">{{flightObj.en_pay_email}}</span>
                            </div>
                        </template>
                        <div class="summary-title">{{getLabel('SUMMARY_ITINERARY')}}</div>
                        <div class="summary-card-img" v-if="flightObj['Itinerary_id'] && flightObj['Itinerary_id'].length">
                            <img :src="flightObj['Itinerary_id'][0]['url']" />
                        </div>
                    </template>
                    <template v-else-if="flightObj.book_mode === 4">
                        <div class="summary-title">{{getLabel('SUMMARY_FLIGHT_OWN')}}</div>
                    </template>
                    <template v-else>
                        <div class="summary-title">{{getLabel('SUMMARY_FLIGHT1')}}</div>
                        <div class="summary-info summary-container">
                            <span class="summary-label">{{getLabel('SUMMARY_FLIGHT1_1')}}</span>
                            <span class="summary-value">{{flightObj.from_city}}</span>
                        </div>
                        <div class="summary-info summary-container">
                            <span class="summary-label">{{getLabel('SUMMARY_FLIGHT_NO')}}</span>
                            <span class="summary-value">{{flightObj.go_flight_no}}</span>
                        </div>
                        <div class="summary-info summary-container">
                            <span class="summary-label">{{getLabel('SUMMARY_FLIGHT1_2')}}</span>
                            <span class="summary-value">{{flightObj.go_date}}</span>
                        </div>
                        <div class="summary-title">{{getLabel('SUMMARY_FLIGHT2')}}</div>
                        <div class="summary-info summary-container">
                            <span class="summary-label">{{getLabel('SUMMARY_FLIGHT2_1')}}</span>
                            <span class="summary-value">{{flightObj.to_city}}</span>
                        </div>
                        <div class="summary-info summary-container">
                            <span class="summary-label">{{getLabel('SUMMARY_FLIGHT_NO')}}</span>
                            <span class="summary-value">{{flightObj.return_flight_no}}</span>
                        </div>
                        <div class="summary-info summary-container">
                            <span class="summary-label">{{getLabel('SUMMARY_FLIGHT2_2')}}</span>
                            <span class="summary-value">{{flightObj.return_date}}</span>
                        </div>
                    </template>
                </div>
                <div class="summary-tag" :class="{undone: !flightIsFinish}" @click="jump('flight')"></div>
            </div>
            <div class="summary-card" v-if="currentUser.residence_city !== 1">
                <div class="summary-header">
                    {{getLabel('HOTEL_TITLE')}}
                    <span class="summary-edit" @click="jump('hotel')">{{getLabel('SUMMARY_EDIT')}}</span>
                </div>
                <div class="summary-content">
                    <img src="../assets/img/hotel.png" style="display: block; margin: 40px auto 20px;"/>
                    <div class="summary-info summary-container">
                        <span class="summary-label">{{getLabel('SUMMARY_CHECK_IN')}}</span>
                        <span class="summary-value summary-blue">{{hotelObj['checkin_date']}}</span>
                    </div>
                    <div class="summary-info summary-container">
                        <span class="summary-label">{{getLabel('SUMMARY_CHECK_OUT')}}</span>
                        <span class="summary-value summary-blue">{{hotelObj['checkout_date']}}</span>
                    </div>
                </div>
                <div class="summary-tag" :class="{undone: not_finish_hotel}" @click="jump('hotel')"></div>
            </div>
            <div class="summary-card" v-if="currentUser.is_lecture">
                <div class="summary-header">
                    {{getLabel('DOCUMENT_TITLE')}}
                    <span class="summary-edit" @click="jump('document')">{{getLabel('SUMMARY_EDIT')}}</span>
                </div>
                <div class="summary-content">
                    <div class="summary-title">{{getLabel('DOCUMENT_LABEL1')}}</div>
                    <div class="summary-info summary-container">{{speech_title}}</div>
                    <div class="summary-title">{{getLabel('SUMMARY_PAPER')}}</div>
                    <div class="summary-info summary-container" v-for="(paper, index) in paper_list" :key="'paper_' + index">
                        <span>{{paper.name}}</span>
                    </div>
                    <div class="summary-title">{{getLabel('SUMMARY_ABSTRACT')}}</div>
                    <div class="summary-info summary-container" v-for="(summary, index) in summary_list" :key="'summary_' + index">
                        <span>{{summary.name}}</span>
                    </div>
                    <div class="summary-title">PPT</div>
                    <div class="summary-info summary-container" v-for="(ppt, index) in ppt_list" :key="'ppt_' + index">
                        <span>{{ppt.name}}</span>
                    </div>
                </div>
                <div class="summary-tag" :class="{undone: not_finish_document}" @click="jump('document')"></div>
            </div>
        </div>
    </div>
</template>

<script>
	import {mapState, mapGetters} from 'vuex';
	import Language from '../util/language';
	import allCountries from '../util/CountriesAll';
	import {Modal} from 'ant-design-vue';

	export default {
		components: {

		},
		data () {
			return {
				allCountries
			}
		},
		mounted() {
			if (!this.activityHasData) {
				this.$store.dispatch('activity/getActivity');
			}
			if (!this.hotelHasData && this.currentUser.residence_city !== 1) {
				this.$store.dispatch('hotel/getHotel');
			}
			if (!this.documentHasData) {
				this.$store.dispatch('document/getDocument');
			}
			if (!this.flightHasData && this.currentUser.residence_city !== 1) {
				this.$store.dispatch('flight/getFlight');
			}
			this.$store.dispatch('flight/queryIsFinish');
		},
		computed: {
			...mapState({
				language: state => state.main.language,
                // 基本信息
				currentUser: state => state.main.currentUser,
                // 活动
				activityHasData: state => state.activity.hasData,
				sortedDate: state => state.activity.sortedDate,
				selectList: state => state.activity.selectList,
				activityObj: state => state.activity.activityObj,
                // 机票
				flightHasData: state => state.flight.hasData,
				flightObj: state => state.flight.flightObj,
				flightIsFinish: state => state.flight.isFinish,
                // 酒店
				hotelHasData: state => state.hotel.hasData,
				hotelObj: state => state.hotel.hotelObj,
                // 文档
				documentHasData: state => state.document.hasData,
				speech_title: state => state.document.documentObj.title,
                paper_list: state => state.document.documentObj.paper,
				summary_list: state => state.document.documentObj.summary,
				ppt_list: state => state.document.documentObj.ppt
			}),
			...mapGetters('main', {
				not_finish_information: 'not_finish_information'
			}),
			...mapGetters('activity', {
				not_finish_activity: 'not_finish_activity'
			}),
			...mapGetters('hotel', {
				not_finish_hotel: 'not_finish_hotel'
			}),
			...mapGetters('document', {
				not_finish_document: 'not_finish_document'
			})
		},
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			},
            // 跳转对应模块
            jump: function (module) {
                const preFix = this.language === 'zh' ? '' : '/en';
                if (this.not_finish_information && module !== 'information') {
	                Modal.confirm({
		                iconType: 'info-circle',
		                title: this.getLabel('SUMMARY_CONFIRM'),
		                okText: this.getLabel('SUMMARY_CONFIRM_OK'),
		                cancelText: this.getLabel('TIP_CANCEL'),
		                onOk: () => {
			                this.$router.push(`${preFix}/information`);
		                },
		                onCancel() {},
	                });
                } else {
	                this.$router.push(`${preFix}/${module}`);
                }
            },
            // 获取性别展示
			getGender: function (genderId) {
                if (genderId === 1) {
                	return this.language === 'zh' ? '男' : 'male';
                } else if (genderId === 2) {
	                return this.language === 'zh' ? '女' : 'female';
                } else {
	                return this.language === 'zh' ? '其他' : 'other';
                }
			},
            // 获取国家
            getCountry: function (code) {
				let _this = this;
				let result = '';
                this.allCountries.map(country => {
                	if (country.code.toString() === code.toString()) {
		                result = _this.language === 'zh' ? country['zh'] : country['en'];
                    }
                });
                return result;
            }
		}
	};
</script>

<style lang="less" scoped>
    .summary {
        padding-bottom: 40px;
        transform: translateX(15px);
        &-row {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
        &-card {
            width: 490px;
            height: 390px;
            margin-bottom: 20px;
            background: #FFF;
            box-shadow: 0 1px 4px 5px rgba(0,0,0,0.02);
            border-radius: 8px;
            overflow: hidden;
            position: relative;
        }
        &-card-img img {
            display: block;
            width: 90%;
            height: auto;
            margin: 0 auto;
            border-radius: 6px;
        }
        &-header {
            height: 45px;
            line-height: 45px;
            background: #00A0ED;
            color: #fff;
            padding-left: 20px;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        &-edit {
            float: right;
            margin-right: 20px;
            cursor: pointer;
        }
        &-content {
            height: 345px;
            overflow: auto;
            padding: 20px;
            -ms-overflow-style: none;
            overflow: -moz-scrollbars-none;
            &::-webkit-scrollbar { width: 0 !important }
        }
        &-title {
            font-size: 14px;
            color: #2099F3;
            margin-bottom: 20px;
        }
        &-info {
            width: 100%;
            font-size: 14px;
            color: #666;
            display: inline-flex;
            justify-content: space-between;
            margin-bottom: 16px;
            position: relative;
            .anticon {
                position: absolute;
                left: -5px;
                top: 5px;
                color: #00A0ED;
            }
            a {
                color: #666;
            }
            &.isCheck {
                background: url(../assets/img/icon-check.png) left top 2px no-repeat;
                background-size: 16px;
            }
        }
        &-container {
            padding-left: 20px;
        }
        &-blue {
            color: #2099F3;
        }
        &-value {
            max-width: 200px;
        }
        &-activityTitle {
            color: #333;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            margin-bottom: 5px;
        }
        &-activityLabel {
            color: #333;
            width: 120px;
            min-width: 120px;
        }
        &-activityValue {
            flex-grow: 1;
            line-height: 1.8;
            max-width: 310px;
        }
        &-address {
            padding-left: 20px;
            background: url(../assets/img/location.png) left top 4px no-repeat;
            background-size: 16px;
            color: #666;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
        }
        .empty {
            color: #E60012;
        }
        &-activity {
            position: relative;
            &:hover {
                .summary-downTip {
                    display: block;
                }
            }
        }
        &-downTip {
            display: none;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 490px;
            height: 55px;
            background: url(../assets/img/down_bj.png) left bottom no-repeat;
            background-size: 100%;
        }
        &-downArrow {
            position: absolute;
            z-index: 10;
            right: 0;
            bottom: 5px;
            left: 0;
            margin: 0 auto;
            width: 15px;
            animation: webSwipeTipAfter 1.5s infinite ease-in-out;
        }
    }
    @keyframes webSwipeTipAfter {
        0% {
            opacity: 1;
        }
        100% {
            transform: translateY(-80%);
            opacity: 0;
        }
    }
    .undone::after {
        cursor: pointer;
        content: '';
        display: block;
        position: absolute;
        right: 0;
        bottom: 0;
        width: 140px;
        height: 140px;
        background: url(../assets/img/unfinished.png) center center #FFF no-repeat;
        background-size: 140px;
    }
    .en .undone::after {
        background: url(../assets/img/unfinished_en.png) center center #FFF no-repeat;
        background-size: 140px;
    }
    .en .summary-activityTitle {
        margin-bottom: 10px;
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
</style>
